import { Parser } from "@siteimprove/alfa-parser";
import { LengthPercentage } from "../../../numeric/index.js";
import { Value } from "../../../value.js";
const { map } = Parser;
/**
 * {@link https://drafts.csswg.org/css-images/#color-transition-hint}
 */
export class Hint extends Value {
    static of(position) {
        return new Hint(position);
    }
    _position;
    constructor(position) {
        super("hint", Value.hasCalculation(position));
        this._position = position;
    }
    get position() {
        return this._position;
    }
    resolve(resolver) {
        return new Hint(LengthPercentage.resolve(resolver)(this._position));
    }
    partiallyResolve(resolver) {
        return new Hint(LengthPercentage.partiallyResolve(resolver)(this._position));
    }
    equals(value) {
        return value instanceof Hint && value._position.equals(this._position);
    }
    hash(hash) {
        hash.writeHashable(this._position);
    }
    toJSON() {
        return {
            type: "hint",
            position: this._position.toJSON(),
        };
    }
    toString() {
        return `${this._position}`;
    }
}
(function (Hint) {
    /**
     * {@link https://drafts.csswg.org/css-images/#typedef-linear-color-hint}
     */
    Hint.parse = map(LengthPercentage.parse, Hint.of);
})(Hint || (Hint = {}));
//# sourceMappingURL=hint.js.map